import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
export interface AlertState {
    isOpen: boolean;
    message?: any;
}
@Injectable({
    providedIn: 'root',
})
export class AlertWrapperService {
    // constructor() {}
    private _isOpen = new BehaviorSubject<AlertState>({
        isOpen: false,
    });
    get isOpen() {
        return this._isOpen.asObservable();
    }

    private setIsOpen(state: AlertState) {
        this._isOpen.next(state);
    }

    public open(message: string, autoCloseDuration?: number) {      
        this.setIsOpen({ isOpen: true, message });
        if (autoCloseDuration) {
            setTimeout(() => {
                this.close();
            }, autoCloseDuration);
        }
    }

    public close() {
        this.setIsOpen({ isOpen: false });
    }
}
